import { render, staticRenderFns } from "./OrgHomeReviewRequests.vue?vue&type=template&id=555c79d2&scoped=true&"
import script from "./OrgHomeReviewRequests.vue?vue&type=script&lang=js&"
export * from "./OrgHomeReviewRequests.vue?vue&type=script&lang=js&"
import style0 from "./OrgHomeReviewRequests.vue?vue&type=style&index=0&id=555c79d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555c79d2",
  null
  
)

export default component.exports